// Assets
export const IMAGES = {
  logo: "/assets/landing/logo-official.png",
  hero: "/assets/landing/hero-official.png",
  service1: "/assets/landing/service-exterior.jpg",
  service2: "/assets/landing/service-interior.jpg",
  service3: "/assets/landing/service-premium.jpg",
  whyUs: "/assets/landing/service-domicilio.jpg",
  paquete1: "/assets/landing/package-exterior.png",
  paquete2: "/assets/landing/package-interior.png",
  paquete3: "/assets/landing/package-premium.png",
  extras: "/assets/landing/banner-extras.png",
  compareBefore: "/assets/landing/compare-before.png",
  compareAfter: "/assets/landing/compare-after.png",
  bitcoin_logo: "/assets/landing/bitcoin-logo.png",
  bitso_qr: "/assets/payments/bitso.jpg",
  bybit_qr: "/assets/payments/bybit.jpg",
  phantom_qr: "/assets/payments/phantom.jpg"
};

export const PARTNER_BRANDS = [
  { id: 'meguiars', name: "Meguiar's", logo: "/assets/brands/meguiars.png" },
  { id: 'armorall', name: "Armor All", logo: "/assets/brands/armorall.png" },
  { id: 'turtlewax', name: "Turtle Wax", logo: "/assets/brands/turtlewax.png" },
  { id: 'proelite', name: "Pro Elite", logo: "/assets/brands/proelite.png" }
];

export const SOCIAL_LINKS = [
  { id: 'facebook', name: 'Facebook', url: 'https://www.facebook.com/share/1DvnZvZDpa/?mibextid=wwXIfr' },
  { id: 'instagram', name: 'Instagram', url: 'https://www.instagram.com/streetprimedetail?igsh=MWZ0aDZoZnJpZTY5dg%3D%3D&utm_source=qr' },
  { id: 'threads', name: 'Threads', url: 'https://www.threads.com/@streetprimedetail?igshid=NTc4MTIwNjQ2YQ==' },
  { id: 'tiktok', name: 'TikTok', url: 'https://www.tiktok.com/@street.prime.detail?_r=1&_t=ZS-95RV8EeA5TA' },
  { id: 'linkedin', name: 'LinkedIn', url: 'https://www.linkedin.com/company/streetprimedetail/' },
  { id: 'kick', name: 'Kick', url: 'https://kick.com/streetprimedetail' }
];

export const CRYPTO = {
  phantom_wallet: "D2XFfeAzbHDCoD45KANnqwQNUkZ4VXX97aeunG6md3F",
  solana_pay_link: "solana:D2XFfeAzbHDCoD45KANnqwQNUkZ4VXX97aeunG6md3F?label=Street%20Prime%20Detail&message=Detallado%20Automotriz%20Premium"
};

export const WHATSAPP_NUMBER = "5572502791";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const GOOGLE_MAPS_LINK = "https://maps.app.goo.gl/aEgjYexBhbJs72g76";
export const WAZE_LINK = "https://waze.com/ul?ll=19.344403,-99.254131&navigate=yes";
export const GOOGLE_MAPS_REVIEW_LINK = "https://g.page/r/CZnxgf7IqHw1EAI/review";

// Pricing Data
export const VEHICLE_TYPES = [
  { id: 'auto_chico', name: 'Auto chico', icon: 'car-sm' },
  { id: 'auto_mediano', name: 'Auto mediano', icon: 'car-md' },
  { id: 'auto_grande', name: 'Auto grande', icon: 'car-lg' },
  { id: 'suv_chica', name: 'SUV chica', icon: 'suv-sm' },
  { id: 'suv_grande', name: 'SUV grande', icon: 'suv-lg' },
  { id: 'camioneta_larga', name: 'Camioneta larga', icon: 'truck-lg' },
  { id: 'camioneta_extra', name: 'Camioneta extra larga', icon: 'truck-xl' },
  { id: 'moto', name: 'Moto', icon: 'motorcycle' }
];

export const PACKAGES = [
  {
    id: 'street_clean',
    name: 'Street Prime Express',
    subtitle: 'El mantenimiento ideal para tu día a día',
    color: '#25D366',
    image: IMAGES.paquete1,
    altText: "Lavado Exterior Profesional - Limpieza a detalle de rines y llantas con productos Armor All",
    prices: {
      auto_chico: 499, auto_mediano: 549, auto_grande: 599,
      suv_chica: 649, suv_grande: 699, camioneta_larga: 799, camioneta_extra: 899,
      moto: 299
    },
    features: [
      'Prelavado de espuma activa',
      'Lavado exterior manual seguro',
      'Limpieza de rines y llantas',
      'Aspirado de habitáculo (no aplica en motos)',
      'Limpieza de tablero y consola',
      'Limpieza interior y exterior de cristales',
      'Secado premium con microfibra',
      'Aplicación de brillo en llantas'
    ],
    motoFeatures: [
      'Prelavado de espuma activa (elimina mosquitos y polvo)',
      'Lavado exterior manual seguro para pintura y plásticos',
      'Limpieza y desengrasado de rines y llantas',
      'Limpieza y detallado básico de mandos y tablero digital',
      'Secado premium con microfibra de alta absorción',
      'Aplicación de brillo y protección en llantas'
    ]
  },
  {
    id: 'street_detail',
    name: 'Street Prime Signature',
    subtitle: 'El favorito de nuestros clientes',
    color: '#FFB800',
    image: IMAGES.paquete2,
    altText: "Limpieza Interior Profunda - Cuidado y protección de vestiduras de piel con tecnología Armor All",
    prices: {
      auto_chico: 899, auto_mediano: 999, auto_grande: 1099,
      suv_chica: 1199, suv_grande: 1299, camioneta_larga: 1499, camioneta_extra: 1699,
      moto: 599
    },
    features: [
      'Lavado exterior a profundidad',
      'Limpieza detallada de plásticos y molduras interiores',
      'Aspiración profunda de asientos y alfombras',
      'Detallado de marcos de puertas',
      'Limpieza básica de cajuela',
      'Restauración estética de plásticos interiores',
      'Acondicionamiento premium de superficies',
      'Acabado satinado profesional'
    ],
    motoFeatures: [
      'Prelavado de espuma activa y lavado exterior detallado',
      'Descontaminado básico de pintura y plásticos expuestos',
      'Limpieza detallada de motor expuesto (remoción de grasa)',
      'Acondicionamiento y protección UV de plásticos y molduras',
      'Acondicionamiento y nutrición de asiento (piel o vinil)',
      'Pulido a mano de escapes y partes cromadas expuestas',
      'Aplicación de sellador protector de pintura (brillo y repelencia al agua)'
    ]
  },
  {
    id: 'street_deep',
    name: 'Street Deep',
    subtitle: 'Detailing completo profesional',
    color: '#1F6AE1',
    image: IMAGES.paquete3,
    altText: "Detallado Automotriz Premium - Corrección de pintura y protección cerámica profesional para vehículos de alta gama",
    prices: {
      auto_chico: 1799, auto_mediano: 1999, auto_grande: 2199,
      suv_chica: 2399, suv_grande: 2699, camioneta_larga: 2999, camioneta_extra: 3399,
      moto: 1199
    },
    features: [
      'Prelavado de espuma activa para desprender contaminantes',
      'Lavado exterior manual a profundidad con técnica segura',
      'Limpieza y detallado de plásticos, molduras y paneles interiores',
      'Detallado de cristales y espejos interiores y exteriores',
      'Aspiración profunda de habitáculo y tapetes',
      'Aspirado y acondicionamiento básico de cajuela',
      'Limpieza de tablero, consola central y portavasos',
      'Brillo y acondicionamiento de llantas y plásticos exteriores',
      'Secado premium con microfibra de alta absorción',
      'Aromatización final del habitáculo'
    ],
    motoFeatures: [
      'Prelavado con espuma activa y descontaminado de pintura',
      'Lavado técnico detallado del motor a fondo con cepillos de precisión',
      'Desengrasado y limpieza profunda de la cadena y basculante trasero',
      'Limpieza detallada de suspensión delantera (barras) y amortiguador',
      'Pulido de parabrisas (si aplica) y cúpula de viento',
      'Acondicionamiento premium de todas las mangueras y cables expuestos',
      'Aplicación de cera premium de Carnauba en tanque y carenado'
    ]
  }
];

export const UPSELLS = [
  {
    id: 'pulido_1_etapa',
    name: 'Pulido de una etapa',
    icon: 'polish',
    allowedPackages: ['street_detail', 'street_deep'],
    prices: { auto_chico: 1200, auto_mediano: 1380, auto_grande: 1560, suv_chica: 1740, suv_grande: 1920, camioneta_larga: 2160, camioneta_extra: 2400, moto: 500 }
  },
  {
    id: 'correccion_multietapa',
    name: 'Corrección de pintura multietapa',
    icon: 'polish',
    allowedPackages: ['street_deep'],
    prices: { auto_chico: 2500, auto_mediano: 2870, auto_grande: 3250, suv_chica: 3620, suv_grande: 4000, camioneta_larga: 4500, camioneta_extra: 5000, moto: 999 }
  },
  {
    id: 'ceramico_6_meses',
    name: 'Tratamiento cerámico 6 meses',
    icon: 'ceramic',
    allowedPackages: ['street_deep'],
    prices: { auto_chico: 1500, auto_mediano: 1720, auto_grande: 1950, suv_chica: 2170, suv_grande: 2400, camioneta_larga: 2700, camioneta_extra: 3000, moto: 800 }
  },
  {
    id: 'ceramico_1_ano',
    name: 'Tratamiento cerámico 1 año',
    icon: 'ceramic',
    allowedPackages: ['street_deep'],
    prices: { auto_chico: 2500, auto_mediano: 2870, auto_grande: 3250, suv_chica: 3620, suv_grande: 4000, camioneta_larga: 4500, camioneta_extra: 5000, moto: 1400 }
  },
  {
    id: 'ceramico_3_anos',
    name: 'Tratamiento cerámico 3 años',
    icon: 'ceramic',
    allowedPackages: ['street_deep'],
    prices: { auto_chico: 4500, auto_mediano: 5170, auto_grande: 5850, suv_chica: 6520, suv_grande: 7200, camioneta_larga: 8100, camioneta_extra: 9000, moto: 2500 }
  },
  {
    id: 'detallado_motor',
    name: 'Detallado de motor',
    icon: 'engine',
    allowedPackages: ['street_clean', 'street_detail', 'street_deep'],
    prices: { auto_chico: 500, auto_mediano: 570, auto_grande: 650, suv_chica: 720, suv_grande: 800, camioneta_larga: 900, camioneta_extra: 1000, moto: 250 }
  },
  {
    id: 'restauracion_faros',
    name: 'Restauración de faros',
    icon: 'engine',
    allowedPackages: ['street_clean', 'street_detail', 'street_deep'],
    prices: { auto_chico: 400, auto_mediano: 460, auto_grande: 520, suv_chica: 580, suv_grande: 640, camioneta_larga: 720, camioneta_extra: 800, moto: 200 }
  },
  {
    id: 'eliminacion_olores',
    name: 'Eliminación de olores',
    icon: 'interior',
    allowedPackages: ['street_clean', 'street_detail', 'street_deep'],
    prices: { auto_chico: 500, auto_mediano: 570, auto_grande: 650, suv_chica: 720, suv_grande: 800, camioneta_larga: 900, camioneta_extra: 1000, moto: 250 }
  },
  {
    id: 'sanitizacion_vapor',
    name: 'Sanitización con vapor',
    icon: 'interior',
    allowedPackages: ['street_clean', 'street_detail', 'street_deep'],
    prices: { auto_chico: 400, auto_mediano: 460, auto_grande: 520, suv_chica: 580, suv_grande: 640, camioneta_larga: 720, camioneta_extra: 800, moto: 200 }
  },
  {
    id: 'proteccion_piel',
    name: 'Protección de piel',
    icon: 'interior',
    allowedPackages: ['street_detail', 'street_deep'],
    prices: { auto_chico: 800, auto_mediano: 920, auto_grande: 1040, suv_chica: 1160, suv_grande: 1280, camioneta_larga: 1440, camioneta_extra: 1600, moto: 200 }
  },
  {
    id: 'proteccion_textiles',
    name: 'Protección de vestiduras textiles',
    icon: 'interior',
    allowedPackages: ['street_detail', 'street_deep'],
    prices: { auto_chico: 700, auto_mediano: 800, auto_grande: 910, suv_chica: 1010, suv_grande: 1120, camioneta_larga: 1260, camioneta_extra: 1400, moto: 0 }
  },
  {
    id: 'pulido_cristales',
    name: 'Pulido de cristales',
    icon: 'glass',
    allowedPackages: ['street_clean', 'street_detail', 'street_deep'],
    prices: { auto_chico: 500, auto_mediano: 570, auto_grande: 650, suv_chica: 720, suv_grande: 800, camioneta_larga: 900, camioneta_extra: 1000, moto: 250 }
  },
  {
    id: 'reparacion_rayones',
    name: 'Reparación de rayones',
    icon: 'polish',
    allowedPackages: ['street_deep'],
    prices: { auto_chico: 600, auto_mediano: 690, auto_grande: 780, suv_chica: 870, suv_grande: 960, camioneta_larga: 1080, camioneta_extra: 1200, moto: 400 }
  },
  {
    id: 'cadena_lubricacion',
    name: 'Limpieza y lubricación de cadena',
    icon: 'chain',
    allowedPackages: ['street_clean', 'street_detail', 'street_deep'],
    prices: { auto_chico: 0, auto_mediano: 0, auto_grande: 0, suv_chica: 0, suv_grande: 0, camioneta_larga: 0, camioneta_extra: 0, moto: 150 }
  }
];

export const CARE_PLANS = [
  {
    id: 'care_mensual',
    name: 'STREET PRIME CARE · MENSUAL',
    price: 999,
    benefits: [
      '1 servicio Street Clean al mes',
      'Aplicable a cualquier tipo de vehículo',
      'Prioridad en agenda',
      '10% de descuento en servicios adicionales'
    ],
    accent: '#25D366'
  },
  {
    id: 'care_bimestral',
    name: 'STREET PRIME CARE · BIMESTRAL',
    price: 1799,
    benefits: [
      '2 servicios Street Clean',
      'Prioridad en agenda',
      '10% de descuento en servicios adicionales'
    ],
    accent: '#1F6AE1'
  },
  {
    id: 'care_trimestral',
    name: 'STREET PRIME CARE · TRIMESTRAL',
    price: 2999,
    benefits: [
      '3 servicios Street Clean',
      'Prioridad máxima en agenda',
      '15% de descuento en servicios adicionales',
      'Protección de llantas incluida una vez'
    ],
    accent: '#FFFFFF'
  }
];

export const TESTIMONIALS = [
  { name: "Carlos Mendoza", location: "Santa Fe, CDMX", rating: 5, text: "Excelente servicio, mi auto quedó como nuevo. Muy profesionales y puntuales. Totalmente recomendados.", vehicle: "BMW Serie 3" },
  { name: "Ana García", location: "Álvaro Obregón", rating: 5, text: "Increíble la atención y el resultado. El detallado premium vale cada peso. Ya es mi servicio de confianza.", vehicle: "Honda CR-V" },
  { name: "Roberto Sánchez", location: "San Ángel", rating: 5, text: "Muy conveniente que vengan a domicilio. El interior de mi camioneta quedó impecable. Volveré a contratar.", vehicle: "Toyota Hilux" },
  { name: "María López", location: "Coyoacán", rating: 5, text: "El mejor servicio de detallado que he probado. Profesionales, amables y con resultados espectaculares.", vehicle: "Mazda CX-5" }
];

export const GALLERY_ITEMS = [
  { id: 1, title: "Detallado Interior Premium", description: "Limpieza profunda de asientos y tablero", image: "https://customer-assets.emergentagent.com/job_auto-detail/artifacts/81groi0z_Detallado%20Interior%20Premium.jpeg" },
  { id: 2, title: "Pulido de Pintura", description: "Corrección de rayones y brillo espejo", image: "https://customer-assets.emergentagent.com/job_auto-detail/artifacts/vu9rim2m_Pulido%20de%20Pintura.jpeg" },
  { id: 3, title: "Lavado Exterior Completo", description: "Eliminación de contaminantes y encerado", image: "https://customer-assets.emergentagent.com/job_auto-detail/artifacts/ae8042wn_Lavado%20Exterior%20Completo.jpeg" },
  { id: 4, title: "BMW Z4 Detallado", description: "Exterior impecable con brillo espejo", image: "https://customer-assets.emergentagent.com/job_auto-detail/artifacts/zln822g6_4.jpeg" },
  { id: 5, title: "Volvo EX30 Premium", description: "Acabado profesional completo", image: "https://customer-assets.emergentagent.com/job_auto-detail/artifacts/ej5sbo9g_6.jpeg" },
  { id: 6, title: "Interior de Lujo", description: "Asientos de piel como nuevos", image: "https://customer-assets.emergentagent.com/job_auto-detail/artifacts/03q0wc0v_interior%20de%20lujo.jpeg" }
];

// Animation variants
export const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
};

